/* LASHBABE concept storefront · interactions */
(function () {
  'use strict';
  var d = document, w = window;
  var RM = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LBC = w.LBC || (w.LBC = {});
  var T = LBC.t || {};
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = LBC.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents / 100);
    function sep(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dec ? ds : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return sep(v, 2, ',', '.');
      if (k === 'amount_no_decimals') return sep(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return sep(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return sep(v, 0, '.', ',');
      return sep(v, 2, '.', ',');
    });
  }
  LBC.money = money;

  /* ---------- toast ---------- */
  var toastEl, tt;
  function toast(msg) {
    toastEl = toastEl || $('#lbc-toast');
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('show'); }, 2800);
  }
  LBC.toast = toast;

  /* ---------- header ---------- */
  var header = $('.lbc-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', w.scrollY > 8); };
    w.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  $$('[data-lbc-mega]').forEach(function (btn) {
    var panel = d.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var t;
    function set(o) { clearTimeout(t); panel.classList.toggle('open', o); btn.setAttribute('aria-expanded', o); }
    btn.addEventListener('click', function () { set(!panel.classList.contains('open')); });
    if (w.matchMedia('(hover:hover)').matches) {
      btn.addEventListener('mouseenter', function () { set(true); });
      [btn, panel].forEach(function (el) { el.addEventListener('mouseleave', function () { t = setTimeout(function () { set(false); }, 160); }); el.addEventListener('mouseenter', function () { clearTimeout(t); }); });
    }
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  });

  /* ---------- drawers ---------- */
  var lastFocus;
  function openDrawer(id) {
    var el = d.getElementById(id); if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    d.documentElement.style.overflow = 'hidden';
    var f = $('button, a, input', $('.panel', el)); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
  }
  function closeDrawer(el) {
    el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
    d.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  LBC.openDrawer = openDrawer;
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lbc-open]');
    if (o) { e.preventDefault(); if (o.getAttribute('data-lbc-open') === 'lbc-cart-drawer') openCartNow(); else openDrawer(o.getAttribute('data-lbc-open')); return; }
    var c = e.target.closest('[data-lbc-close]');
    if (c) { var dr = c.closest('.lbc-drawer'); if (dr) closeDrawer(dr); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.lbc-drawer.open').forEach(closeDrawer); });

  /* ---------- cart (Section Rendering API) ---------- */
  function setCount(n) {
    $$('[data-lbc-count]').forEach(function (el) {
      el.textContent = n; if (n > 0) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', '');
      if (!RM) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
  }
  function refreshCart(open) {
    return fetch(ROOT + '?sections=lbc-cart', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['lbc-cart']; if (!html) return;
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var fresh = $('.lbc-cart-inner', tmp), cur = $('#lbc-cart-drawer .lbc-cart-inner');
        if (fresh && cur) cur.replaceWith(fresh);
        var n = fresh && fresh.getAttribute('data-count'); if (n != null) setCount(parseInt(n, 10));
        if (open) openDrawer('lbc-cart-drawer');
        requestAnimationFrame(function () { $$('#lbc-cart-drawer .lbc-bar i').forEach(function (i) { i.style.setProperty('--p', i.getAttribute('data-p')); }); });
        updateShipRow();
        return fixGifts(fresh);
      }).catch(function () { if (open) w.location.href = ROOT.replace(/\/$/, '') + '/cart'; });
  }
  LBC.refreshCart = refreshCart;

  /* PDP "€X away from free shipping" row: rendered on page load only, so refresh it from cart.js after the cart changes (2026-10-08, JP) */
  function updateShipRow() {
    var row = $('[data-lbc-ship]'); if (!row) return;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var amt = parseInt(row.getAttribute('data-lbc-ship'), 10); if (!amt) return;
        var left = amt - c.total_price, txt = $('[data-lbc-ship-txt]', row), bar = $('.ship-bar i', row), p = Math.min(1, c.total_price / amt);
        if (txt) {
          if (left > 0) txt.textContent = (row.getAttribute('data-tpl') || '').replace('[v]', money(left));
          else { var b = d.createElement('b'); b.textContent = row.getAttribute('data-ok') || ''; txt.innerHTML = ''; txt.appendChild(b); }
        }
        if (bar) { bar.setAttribute('data-p', p); bar.style.setProperty('--p', p); }
      }).catch(function () {});
  }
  LBC.updateShipRow = updateShipRow;

  /* bag icon: open the drawer straight away with the content already on the page, then refresh it in the background */
  function openCartNow() {
    var dr = d.getElementById('lbc-cart-drawer');
    if (!dr) { w.location.href = ROOT.replace(/\/$/, '') + '/cart'; return; }
    openDrawer('lbc-cart-drawer');
    dr.classList.add('is-loading'); dr.setAttribute('aria-busy', 'true');
    var done = function () {
      dr.classList.remove('is-loading'); dr.removeAttribute('aria-busy');
      var panel = $('.panel', dr);
      if (dr.classList.contains('open') && panel && !panel.contains(d.activeElement)) { var f = $('button, a, input', panel); if (f) f.focus({ preventScroll: true }); }
    };
    refreshCart(false).then(done, done);
  }
  LBC.openCart = openCartNow;

  /* translated error text (LBC.t.error comes from snippets/lbc-t), with a language fallback */
  function errMsg(err) {
    var m = err && (err.description || err.message);
    if (typeof m === 'string' && m) return m;
    if (T.error) return T.error;
    var lg = (d.documentElement.lang || '').slice(0, 2).toLowerCase();
    return lg === 'nl' ? 'Er ging iets mis, probeer het opnieuw' : lg === 'de' ? 'Etwas ist schiefgelaufen, bitte versuch es erneut' : lg === 'fr' ? 'Une erreur est survenue, réessaie' : 'Something went wrong, please try again';
  }

  /* gift guard: the cart section lists free gifts that are no longer allowed (paid total under the threshold, more than 2, or qty > 1) */
  var fixing = 0;
  function fixGifts(inner) {
    inner = inner || $('#lbc-cart-drawer .lbc-cart-inner');
    var raw = inner && inner.getAttribute('data-lbc-fix');
    if (!raw) { fixing = 0; return; }
    if (fixing > 2) return;
    var updates; try { updates = JSON.parse(raw); } catch (e) { return; }
    fixing++;
    return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { return refreshCart(false); });
  }
  LBC.fixGifts = fixGifts;
  fixGifts();
  d.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector || !f.querySelector('[name=checkout]')) return;
    var inner = $('#lbc-cart-drawer .lbc-cart-inner');
    if (inner && inner.getAttribute('data-lbc-fix')) { e.preventDefault(); fixGifts(inner); }
  }, true);

  /* restore an add button to its stored original label (stored once per tap in data-lbc-label) */
  function restoreBtn(btn, swap) {
    var l = $('.lbl', btn), old = btn.dataset.lbcLabel;
    btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
    var fin = function () { if (l && old != null) l.innerHTML = old; if (l) l.classList.remove('swap'); delete btn.dataset.lbcLabel; btn.classList.remove('is-done'); };
    if (swap && l && !RM) { l.classList.add('swap'); setTimeout(fin, 160); } else fin();
  }

  function addToCart(items, btn) {
    /* repeat taps while a request is in flight or while "Added" is showing: ignore */
    if (btn && (btn.classList.contains('is-loading') || btn.classList.contains('is-done') || btn.dataset.lbcLabel != null)) return Promise.resolve();
    if (btn) {
      var l0 = $('.lbl', btn); if (l0) btn.dataset.lbcLabel = l0.innerHTML;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (btn) {
          btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.classList.add('is-done');
          var l = $('.lbl', btn);
          if (l) { l.classList.add('swap'); setTimeout(function () { if (btn.classList.contains('is-done')) l.innerHTML = (T.added || 'Added') + ' ✓'; l.classList.remove('swap'); }, 160); }
          setTimeout(function () { restoreBtn(btn, true); }, 1700);
        }
        return refreshCart(true);
      })
      .catch(function (err) {
        if (btn) restoreBtn(btn, false);
        toast(errMsg(err));
      });
  }
  LBC.addToCart = addToCart;

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lbc-add]');
    if (b && !b.disabled) {
      e.preventDefault();
      var isBtn = b.classList.contains('lbc-btn');
      /* small + / option buttons: show a busy state and block repeat taps until the bag has answered */
      if (!isBtn) { if (b.getAttribute('aria-busy') === 'true') return; b.setAttribute('aria-busy', 'true'); if ('disabled' in b) b.disabled = true; }
      var done = addToCart([{ id: parseInt(b.getAttribute('data-lbc-add'), 10), quantity: 1 }], isBtn ? b : null);
      if (!isBtn && done && done.then) done.then(function () { b.removeAttribute('aria-busy'); if ('disabled' in b) b.disabled = false; });
      return;
    }
    var q = e.target.closest('[data-lbc-qty]');
    if (q) {
      e.preventDefault();
      var key = q.getAttribute('data-key'), qty = parseInt(q.getAttribute('data-lbc-qty'), 10);
      var line = q.closest('.lbc-line');
      if (line && line.getAttribute('aria-busy') === 'true') return;
      var unbusy = function () { if (line) { line.style.opacity = ''; line.style.pointerEvents = ''; line.removeAttribute('aria-busy'); } };
      if (line) { line.style.opacity = '.5'; line.style.pointerEvents = 'none'; line.setAttribute('aria-busy', 'true'); }
      fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(false); })
        .then(unbusy, function (err) { unbusy(); toast(errMsg(err)); });
    }
  });

  /* product form (PDP + featured) */
  $$('form[data-lbc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]'), qty = form.querySelector('[name="quantity"]');
      var btn = form.querySelector('[type="submit"]');
      addToCart([{ id: parseInt(id.value, 10), quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1 }], btn);
    });
  });

  /* ---------- quantity steppers ---------- */
  d.addEventListener('click', function (e) {
    var s = e.target.closest('[data-step]'); if (!s) return;
    var inp = s.parentNode.querySelector('input'); if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(s.getAttribute('data-step'), 10));
  });

  /* ---------- PDP variant picker ---------- */
  $$('[data-lbc-pdp]').forEach(function (root) {
    var dataEl = $('[data-lbc-product]', root); if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (err) { console.warn('[LBC product]', err); return; }
    var form = $('form[data-lbc-form]', root);
    var idInput = form && form.querySelector('[name="id"]');
    var groups = $$('[data-lbc-option]', root);
    var priceEl = $('[data-lbc-price]', root), compEl = $('[data-lbc-compare]', root), saveEl = $('[data-lbc-save]', root);
    var btn = form && form.querySelector('[type="submit"]'), btnLbl = btn && $('.lbl', btn);
    var sticky = $('.lbc-sticky'), sVar = sticky && $('[data-lbc-sticky-variant]', sticky), sBtn = sticky && $('[data-lbc-sticky-btn]', sticky);
    function setLbl(html) { if (!btn || !btnLbl) return; if (btn.dataset.lbcLabel != null) btn.dataset.lbcLabel = html; else btnLbl.innerHTML = html; }
    function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function find(opts) { if (!opts.length) return product.variants[0]; return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
    function paintAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('.lbc-chip', g).forEach(function (chip) {
          var val = $('input', chip).value, test = opts.slice(); test[gi] = val;
          var v = find(test); chip.classList.toggle('unavail', !v || !v.available);
        });
        var lab = $('[data-lbc-option-value]', g); if (lab) lab.textContent = opts[gi] || '';
      });
    }
    function update(push) {
      var opts = selected(), v = find(opts);
      paintAvailability(opts);
      if (!v) { if (btn) { btn.disabled = true; setLbl(T.unavailable || 'Unavailable'); } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compEl) { compEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      if (saveEl) { var s = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0; saveEl.hidden = !s; saveEl.textContent = (T.save || 'Save') + ' ' + money(s); }
      if (btn) {
        btn.disabled = !v.available;
        setLbl(v.available ? (T.add_to_bag || 'Add to bag') + '<span class="pr"> · ' + money(v.price) + '</span> <span class="ar">→</span>' : (T.sold_out || 'Sold out'));
      }
      if (sVar) sVar.textContent = (v.title !== 'Default Title' ? v.title + ' · ' : '') + money(v.price);
      if (sBtn) sBtn.disabled = !v.available;
      if (push && w.history.replaceState) { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u); }
      if (v.featured_media && push) { var g = $('[data-lbc-gallery]', root); if (g && g.lbcGo) g.lbcGo(v.featured_media.id); }
      d.dispatchEvent(new CustomEvent('lbc:variant', { detail: v }));
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    update(false);
    if (sticky && form) {
      var io = new IntersectionObserver(function (es) { sticky.classList.toggle('show', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); });
      io.observe(form);
      if (sBtn) sBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    }
  });

  /* ---------- gallery ---------- */
  $$('[data-lbc-gallery]').forEach(function (g) {
    var main = $('.main', g), slides = $$('.slide', g), thumbs = $$('.thumbs button', g), count = $('.count', g);
    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (thumbs[i] && thumbs[i].scrollIntoView && w.innerWidth > 900) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function go(i, smooth) { if (!slides[i]) return; main.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || RM ? 'auto' : 'smooth' }); mark(i); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var st; main.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(Math.round(main.scrollLeft / main.clientWidth)); }, 60); }, { passive: true });
    g.lbcGo = function (mediaId) { var i = slides.findIndex(function (s) { return s.getAttribute('data-media') == mediaId; }); if (i > -1) go(i); };
    mark(0);
  });

  /* ---------- accordions (animated height) ---------- */
  $$('.lbc-acc details').forEach(function (det) {
    var sum = $('summary', det), ans = $('.ans', det); if (!ans || RM) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (det.open) {
        var h = ans.offsetHeight;
        ans.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(0.23,1,0.32,1)' }).onfinish = function () { det.open = false; };
      } else {
        det.open = true; var h2 = ans.offsetHeight;
        ans.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(0.23,1,0.32,1)' });
      }
    });
  });

  /* ---------- delivery countdown + free-shipping bars ---------- */
  /* time in Amsterdam (not the phone clock): weekday 0=Sun..6=Sat, minutes since midnight */
  var amsFmt = null;
  try { amsFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); } catch (e) { amsFmt = null; }
  function amsNow() {
    var now = new Date();
    if (amsFmt && amsFmt.formatToParts) {
      var p = {}; amsFmt.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      var wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), hh = parseInt(p.hour, 10) % 24, mm = parseInt(p.minute, 10);
      if (wd > -1 && !isNaN(hh) && !isNaN(mm)) return { wd: wd, min: hh * 60 + mm };
    }
    return { wd: now.getDay(), min: now.getHours() * 60 + now.getMinutes() };
  }
  function cutoff() {
    var els = $$('[data-lbc-cutoff]'); if (!els.length) return;
    var a = amsNow(), CUT = 22 * 60;
    /* Friday after 22:00, Saturday and Sunday: no next-day promise, hide the line */
    var off = (a.wd === 5 && a.min >= CUT) || a.wd === 6 || a.wd === 0;
    var m = a.min < CUT ? CUT - a.min : 24 * 60 - a.min + CUT;
    els.forEach(function (el) {
      var row = el.closest('.lbc-assure > div') || el.parentNode;
      if (row) row.hidden = off;
      if (!off) el.textContent = Math.floor(m / 60) + (T.h || 'h') + ' ' + String(m % 60).padStart(2, '0') + (T.m || 'm');
    });
  }
  cutoff(); setInterval(cutoff, 30000);
  $$('.lbc-bar i[data-p], .ship-bar i[data-p]').forEach(function (i) { requestAnimationFrame(function () { i.style.setProperty('--p', i.getAttribute('data-p')); }); });

  /* ---------- cookie banner (Pandectes GDPR app embed) above the sticky add-to-bag ----------
     While a consent banner is visible, html gets .lbc-consent-open and the sticky bar is hidden (CSS). Pandectes is the active
     embed; the other selectors are common consent containers kept as a fallback. Light: short poll to find it, then observe it. */
  if ($('.lbc-sticky')) {
    var CONSENT = '#pandectes-banner,.pd-cp-ui,#shopify-pc__banner,.cc-window,#cookie-banner,.cookie-banner,[id^="isense-cc"],#CybotCookiebotDialog,#onetrust-banner-sdk';
    var cRoot = d.documentElement, cObs = null, cSeen = [];
    var cVisible = function (el) {
      if (!el || !el.isConnected || el.hidden || el.classList.contains('cc-invisible')) return false;
      var cs = w.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.width > 0 && r.bottom > 0 && r.top < w.innerHeight;
    };
    var cCheck = function () {
      var els = $$(CONSENT), open = els.some(cVisible);
      cRoot.classList.toggle('lbc-consent-open', open);
      els.forEach(function (el) {
        if (cSeen.indexOf(el) > -1 || !('MutationObserver' in w)) return;
        cSeen.push(el);
        cObs = cObs || new MutationObserver(function () { clearTimeout(cCheck.t); cCheck.t = setTimeout(cCheck, 120); });
        cObs.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        if (el.parentNode) cObs.observe(el.parentNode, { childList: true });
      });
      return els.length;
    };
    var cTries = 0, cPoll = setInterval(function () { cTries++; if (cCheck() && cTries > 3) clearInterval(cPoll); else if (cTries > 25) clearInterval(cPoll); }, 800);
    cCheck();
    /* Accept / Reject / close taps on the banner: re-check once its own animation has finished */
    d.addEventListener('click', function () { if (cRoot.classList.contains('lbc-consent-open')) { setTimeout(cCheck, 450); setTimeout(cCheck, 1200); } }, true);
  }

  /* ---------- reveals ---------- */
  if ('IntersectionObserver' in w && !RM) {
    var ro = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('pre'); ro.unobserve(e.target); } }); }, { rootMargin: '0px 0px -60px 0px' });
    $$('.lbc .rv').forEach(function (el) { if (el.getBoundingClientRect().top > w.innerHeight * 0.92) { el.classList.add('pre'); ro.observe(el); } });
    var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('shine'); so.unobserve(e.target); } }); }, { threshold: .8 });
    $$('.lbc-btn[data-shine]').forEach(function (b) { so.observe(b); });
  }

  /* ---------- quiz ---------- */
  $$('[data-lbc-quiz]').forEach(function (q) {
    var cfg; try { cfg = JSON.parse($('[data-lbc-quiz-data]', q).textContent); } catch (err) { console.warn('[LBC quiz]', err); return; }
    var box = $('.q', q), prog = $$('.prog i', q), step = 0, ans = [];
    function render() {
      prog.forEach(function (p, i) { p.classList.toggle('on', i <= step); });
      var html;
      if (step < cfg.questions.length) {
        var qq = cfg.questions[step];
        html = '<h3 class="lbc-h-l">' + qq.q + '</h3><div class="opts">' + qq.o.map(function (o, i) { return '<button type="button" data-i="' + i + '"><span><b>' + o.t + '</b><span>' + o.s + '</span></span><span aria-hidden="true">→</span></button>'; }).join('') + '</div>';
      } else {
          var tally = {};
          ans.forEach(function (ai, qi) {
            var q0 = cfg.questions[qi], opt = q0 && q0.o && q0.o[ai], w = opt && opt.w;
            if (!w) return;
            for (var wk in w) { if (Object.prototype.hasOwnProperty.call(w, wk)) tally[wk] = (tally[wk] || 0) + w[wk]; }
          });
          var ord = cfg.order || Object.keys(cfg.results || {});
          var key = null, best = -1;
          ord.forEach(function (ok) {
            if (!cfg.results || !cfg.results[ok]) return;
            var val = tally[ok] || 0;
            if (val > best) { best = val; key = ok; }
          });
          var r = (cfg.results && (cfg.results[key] || cfg.results[ord[0]])) || cfg.results.vitamins;
        html = '<p class="lbc-caps lbc-small" style="color:#CFC6BE">' + cfg.match + '</p><div class="res">' + (r.img ? '<img src="' + r.img + '" alt="">' : '<span></span>') + '<div style="display:grid;gap:8px"><b class="lbc-h-m">' + r.title + '</b><span class="lbc-sub">' + r.why + '</span><span class="lbc-num">' + r.price + '</span></div></div><div class="lbc-ctas">' + (r.variant ? '<button class="lbc-btn light" data-lbc-add="' + r.variant + '"><span class="spin"></span><span class="lbl">' + (T.add_to_bag || 'Add to bag') + ' <span class="ar">→</span></span></button>' : '') + '<a class="lbc-btn line" style="--fg:var(--cream);border-color:var(--cream);--hbg:var(--cream)" href="' + r.url + '">' + cfg.view + '</a>' + (cfg.studio ? '<a class="lbc-ulink" href="' + cfg.studio.url + '" style="color:var(--cream)">' + cfg.studio.t + '</a>' : '') + '<button class="lbc-ulink" type="button" data-restart style="border:0;background:none;color:var(--cream)">' + cfg.restart + '</button></div>';
      }
      if (RM) { box.innerHTML = html; return; }
      box.classList.add('swap'); setTimeout(function () { box.innerHTML = html; box.classList.remove('swap'); }, 220);
    }
    q.addEventListener('click', function (e) {
      var o = e.target.closest('[data-i]'); if (o) { ans[step] = parseInt(o.getAttribute('data-i'), 10); step++; render(); return; }
      if (e.target.closest('[data-restart]')) { step = 0; ans = []; render(); }
    });
    render();
  });

  /* ---------- localization selects ---------- */
  $$('[data-lbc-loc]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- 3D showcase lazy boot ---------- */
  var s3 = $$('[data-lbc-3d]:not(#lbc-3d)');
  if (s3.length) {
    var boot = function (sec) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.hardwareConcurrency||8) <= 4 || (navigator.deviceMemory||8) <= 2 || (navigator.connection||{}).saveData) return;
      if (sec.__booted) return; sec.__booted = true;
      var src = sec.getAttribute('data-src');
      import(src).then(function (m) { m.default(sec); }).catch(function (err) { console.warn('3D showcase unavailable', err); });
    };
    if ('IntersectionObserver' in w) {
      var o3 = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { boot(e.target); o3.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
      s3.forEach(function (s) { o3.observe(s); });
    } else s3.forEach(boot);
  }
})();
